import axiosInstance from "../app/axios";

export const createClientApi = async (data: any) => {
  const result = await axiosInstance.post("admin/users", data);
  return result.data;
};

export const editClientApi = async (data: any, id: string | number) => {
  const result = await axiosInstance.patch(`admin/users/${id}`, data);
  return result.data;
};

export const deleteClientApi = async (id: string | number) => {
  const result = await axiosInstance.delete(`admin/users/${id}`);
  return result.data;
};
